import Daycounts from "constants/daycounts";

import {
  LIBOR_FORWARD_CURVE,
  LIBOR_THREE_MONTH_FORWARD_CURVE,
  LIBOR_SIX_MONTH_FORWARD_CURVE,
  LIBOR_TWELVE_MONTH_FORWARD_CURVE,
  THIRTY_DAY_AVG_SOFR_FORWARD_CURVE,
  OVERNIGHT_SOFR_FORWARD_CURVE,
  FED_FUNDS_FORWARD_CURVE,
  SIFMA_FORWARD_CURVE,
  PRIME_FORWARD_CURVE,
  CAP_VOLS,
  TREASURIES,
  SEMIBOND,
  MARKET_EXPECTATIONS_SHOCK,
  PARALLEL_SHOCK,
  STANDARD_DEVIATION_SHOCK,
  TREASURY,
  INTERNALLY_FIXED,
  SEMIBOND_SWAPS
} from "./Constants";
import InterestRateType from "./InterestRateType";
import AmortizationType from "./AmortizationType";
import BusinessDayAdjustmentMethods from "./BusinessDayAdjustmentMethods";
import InterestRateRounding from "./InterestRateRounding";
import DayCount from "./DayCount";
import PrepaymentType from "./PrepaymentType";

const THIRTY_DAY_AVG_SOFR_FORWARD_CURVE_ID = "d48732b4-6011-4ef5-8098-98691f75e7ec";

// Prepayment Details
export const prepaymentTypes = [
  { name: "None", label: "", value: "" },
  { name: "Yield Maintenance", label: "Yield Maintenance", value: PrepaymentType.YIELD_MAINTENANCE_TRADITIONAL },
  { name: "Yield Maintenance - Agency", label: "Yield Maintenance - Agency", value: PrepaymentType.YIELD_MAINTENANCE_AGENCY_STYLE },
  { name: "Defeasance", label: "Defeasance", value: PrepaymentType.DEFEASANCE },
  { name: "Make Whole", label: "Make Whole", value: PrepaymentType.MAKE_WHOLE },
  { name: "Spread Maintenance", label: "Spread Maintenance", value: PrepaymentType.SPREAD_MAINTENANCE },
  { name: "Aggregate Interest", label: "Aggregate Interest", value: PrepaymentType.AGGREGATE_INTEREST },
  { name: "Flat Percentage", label: "Flat Percentage", value: PrepaymentType.FLAT_PERCENTAGE }
];

export const aggregateInterestMethods = [
  { name: "None", label: "", value: "" },
  { name: "Defined", label: "Defined", value: "DEFINED" },
  { name: "Formulaic", label: "Formulaic", value: "FORMULAIC" }
];

// Loan Information
export const dayCountTypes = [
  { name: "None", label: "", value: "" },
  { name: "Act/360", label: "Act/360", value: DayCount.ACTUAL_OVER_360 },
  { name: "30/360", label: "30/360", value: DayCount.THIRTY_OVER_360 },
  { name: "Act/365", label: "Act/365", value: DayCount.ACTUAL_OVER_365 }
];

export const daycountIdsList = [
  { name: "None", label: "", value: "" },
  { name: "Act/360", label: "Act/360", value: Daycounts.ACTUAL_OVER_360 },
  { name: "30/360", label: "30/360", value: Daycounts.THIRTY_OVER_360 },
  { name: "Act/365", label: "Act/365", value: Daycounts.ACTUAL_OVER_365 }
];

// Interest Rates
export const interestRateTypes = [
  { name: "None", label: "", value: "" },
  { name: "Fixed", label: "Fixed", value: InterestRateType.FIXED_RATE },
  { name: "Floating", label: "Floating", value: InterestRateType.FLOATING_RATE }
];

export const interestRateTypeIds = [
  { name: "None", label: "", value: "" },
  { name: "Fixed", label: "Fixed", value: InterestRateType.FIXED_RATE_ID },
  { name: "Floating", label: "Floating", value: InterestRateType.FLOATING_RATE_ID }
];

export const fixedRateIndexes = [
  { name: "none", label: "", value: "" },
  { name: "Treasury", label: "Treasury", value: TREASURY },
  { name: "Semi-Bond Swaps", label: "Semi-Bond Swaps", value: SEMIBOND_SWAPS },
  { name: "Internally Fixed", label: "Internally Fixed", value: INTERNALLY_FIXED }
];

export const curves = [
  { name: "None", label: "", value: "" },
  { name: "1-Month LIBOR/Term SOFR", label: "1-Month LIBOR/Term SOFR", value: LIBOR_FORWARD_CURVE },
  { name: "3-Month LIBOR/Term SOFR", label: "3-Month LIBOR/Term SOFR", value: LIBOR_THREE_MONTH_FORWARD_CURVE },
  { name: "6-Month LIBOR/Term SOFR", label: "6-Month LIBOR/Term SOFR", value: LIBOR_SIX_MONTH_FORWARD_CURVE },
  { name: "Term SOFR", label: "Term SOFR", value: LIBOR_TWELVE_MONTH_FORWARD_CURVE },
  { name: "30 Day Avg SOFR", label: "30 Day Avg SOFR", value: THIRTY_DAY_AVG_SOFR_FORWARD_CURVE_ID},
  { name: "Overnight SOFR", label: "Overnight SOFR", value: OVERNIGHT_SOFR_FORWARD_CURVE },
  { name: "Fed Funds", label: "Fed Funds", value: FED_FUNDS_FORWARD_CURVE },
  { name: "SIFMA", label: "SIFMA", value: SIFMA_FORWARD_CURVE },
  { name: "Prime", label: "Prime", value: PRIME_FORWARD_CURVE },
  { name: "Cap Vols", label: "Cap Vols", value: CAP_VOLS }
];

export const shocks = [
  { name: "Market Expectations", label: "Market Expectations", value: MARKET_EXPECTATIONS_SHOCK },
  { name: "Parallel Shift", label: "Parallel Shift", value: PARALLEL_SHOCK },
  { name: "Standard Deviation", label: "Standard Deviation", value: STANDARD_DEVIATION_SHOCK }
];

// Amortization
export const yieldCurves = [
  { name: "Treasuries", label: "Treasuries", value: TREASURIES },
  { name: "Semi Bond", label: "Semi Bond", value: SEMIBOND }
];

export const amortTypes = [
  { name: "Interest Only", label: "Interest Only", value: AmortizationType.INTEREST_ONLY },
  { name: "Straight Line", label: "Straight Line", value: AmortizationType.STRAIGHT_LINE },
  { name: "Straight Line - Custom", label: "Straight Line - Custom", value: AmortizationType.STRAIGHT_LINE_CUSTOM_AMOUNT },
  { name: "Mortgage Style", label: "Mortgage Style", value: AmortizationType.MORTGAGE_STYLE },
  { name: "Agency Floater", label: "Agency Floater", value: AmortizationType.AGENCY_FLOATER }
];

export const amortTypesShort = [
  { name: "None", label: "", value: "" },
  { name: "Interest Only", label: "Interest Only", value: AmortizationType.INTEREST_ONLY },
  { name: "Mortgage Style", label: "Mortgage Style", value: AmortizationType.MORTGAGE_STYLE },
  { name: "Agency Floater", label: "Agency Floater", value: AmortizationType.AGENCY_FLOATER }
];

export const amortTypesIdsShort = [
  { name: "None", label: "", value: "" },
  { name: "Interest Only", label: "Interest Only", value: AmortizationType.INTEREST_ONLY_ID },
  { name: "Mortgage Style", label: "Mortgage Style", value: AmortizationType.MORTGAGE_STYLE_ID },
  { name: "Agency Floater", label: "Agency Floater", value: AmortizationType.AGENCY_FLOATER_ID }
];

export const businessDayAdjustmentMethods = [
  { name: "Preceding", label: "Preceding", value: BusinessDayAdjustmentMethods.PRECEDING },
  { name: "Modified Preceding", label: "Modified Preceding", value: BusinessDayAdjustmentMethods.MODIFIED_PRECEDING },
  { name: "Following", label: "Following", value: BusinessDayAdjustmentMethods.FOLLOWING },
  { name: "Modified Following", label: "Modified Following", value: BusinessDayAdjustmentMethods.MODIFIED_FOLLOWING }
];

export const interestRateRounding = [
  { name: "No Rounding", label: "No Rounding", value: InterestRateRounding.NO_ROUNDING },
  { name: "One Tenth", label: "One Tenth", value: InterestRateRounding.ONE_TENTH },
  { name: "One Hundredth", label: "One Hundredth", value: InterestRateRounding.ONE_HUNDREDTH },
  { name: "One Thousandth", label: "One Thousandth", value: InterestRateRounding.ONE_THOUSANDTH },
  { name: "One Ten Thousandth", label: "One Ten Thousandth", value: InterestRateRounding.ONE_TEN_THOUSANDTH },
  { name: "One Eigth", label: "One Eigth", value: InterestRateRounding.ONE_EIGTH },
  { name: "One Sixteenth", label: "One Sixteenth", value: InterestRateRounding.ONE_SIXTEENTH },
  { name: "One Thirty Second", label: "One Thirty Second", value: InterestRateRounding.ONE_THIRTY_SECOND },
  { name: "One Sixty Fourth", label: "One Sixty Fourth", value: InterestRateRounding.ONE_SIXTY_FOURTH }
];

export const preferredConstraintList = [
  { name: "None", label: "", value: "" },
  { name: "LTV", label: "LTV", value: "96399d07-91d5-49d5-8882-1babfd69cda0" },
  { name: "DSCR", label: "DSCR", value: "96399d07-91d5-49d5-8882-1babfd69cda1" },
  { name: "DY", label: "DY", value: "96399d07-91d5-49d5-8882-1babfd69cda2" },
  { name: "Min", label: "Min", value: "96399d07-91d5-49d5-8882-1babfd69cda3" },
  { name: "Max", label: "Max", value: "96399d07-91d5-49d5-8882-1babfd69cda4" }
];

export const dayOfMonth = Array.from(new Array(31), (item, index) => ({
  name: `${index + 1}`,
  label: `${index + 1}`,
  value: index + 1
}));

export const loanProceedsSpreadTerms = [
  { name: "None", label: "", value: "" },
  { name: "3 Years", label: "3 Years", value: 3 },
  { name: "5 Years", label: "5 Years", value: 5 },
  { name: "7 Years", label: "7 Years", value: 7 },
  { name: "10 Years", label: "10 Years", value: 10 },
  { name: "15 Years", label: "15 Years", value: 15 },
  { name: "20 Years", label: "20 Years", value: 20 },
  { name: "25 Years", label: "25 Years", value: 25 },
  { name: "30 Years", label: "30 Years", value: 30 }
];
